// extracted by mini-css-extract-plugin
module.exports = {"video":"video--2CXYR","modal":"modal--pqArm","body":"body--2XUKE","iframe":"iframe--2gBJP","wrapper":"wrapper--H6JLU","footer":"footer--2g2OG"};